// extracted by mini-css-extract-plugin
export default {"sr-only":"sr-only__fRyoV","skip-to-content":"skip-to-content__ETXNp"};